import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=88894230&lang=pug&"
import script from "./Navigator.vue?vue&type=script&lang=js&"
export * from "./Navigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports